/* eslint-disable no-console */

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 15:21:56
 * @LastEditTime: 2022-01-08 15:13:38
 * @LastEditors: wangshengqiang
 * @Description: 订单信息确认
 */

/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { get } from 'lodash';
import { useStore } from '@/store';
import { log } from '@/utils/utils';
import { DetailItem } from './transformValue';
import ConfirmInfoTitle from './ConfirmInfoTitle';
import './index.less'; // 定义确认字段从订单数据中的取值路径

const valueMapPath = {
  insurancePeriod: 'extraInfo.insurancePeriod',
  premium: 'extraInfo.firstPremium'
};

const OrderInfoConfirm = props => {
  const {
    attrs,
    label
  } = props;
  const {
    dataSource = [],
    isDefault
  } = attrs;

  if (!isDefault) {
    return null;
  }

  const data = useStore('orderDetail') || {
    insuredList: [],
    extraInfo: {
      insurancePeriod: ''
    }
  };
  const Filter = dataSource.filter(item => item.isDefault === true);

  if (Filter.length === 0) {
    return null;
  }

  if (!data) {
    return null;
  }

  const getValueFromData = valueKey => {
    if (valueMapPath[valueKey]) {
      return get(data, valueMapPath[valueKey]) || get(data, valueKey);
    }

    return get(data, valueKey);
  };

  return /*#__PURE__*/React.createElement("div", {
    id: "orderInfoConfirm",
    className: "c-InfoConfirm bg-fff"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement(ConfirmInfoTitle, {
    title: label
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, Filter.map(item => {
    const _value = getValueFromData(item.value);

    if (!_value) {
      log(`${item.label}: 没有获取到`, item);
      log('当前订单数据为', data);
    }

    return /*#__PURE__*/React.createElement(DetailItem, {
      itemValue: _value,
      dataSource: item.dataSource,
      itemlabel: item.label,
      itemKey: item.value,
      key: item.value
    });
  })));
};

export default OrderInfoConfirm;